import moment from 'moment';

const CreateTicketFormFields = (fieldsList, values) => {
    const fieldsContent = (item, index) => {
        const data = values[index]
        switch (Number(item.type)) {
            /* date input */
            case 1:
                return {
                    content: data ? data.startOf('day').unix() : "",
                    content_value: data ? data.startOf('day').format('YYYY-MM-DD HH:mm:ss') : ""
                }
            /* date + time */
            case 2:
                if (data.date && data.time) {
                    const date = data.date.format('YYYY-MM-DD');
                    const time = data.time.format('HH:mm:ss')
                    const allTime = moment(`${date} ${time}`, "YYYY-MM-DD HH:mm:ss")
                    return {
                        content: allTime.unix(),
                        content_value: allTime.format('YYYY-MM-DD HH:mm:ss')
                    }
                } else {
                    return {
                        content: "",
                        content_value: ""
                    }
                }
            /* multi line text input */
            case 3:
                return {
                    content: JSON.stringify(data),
                    content_value: data
                }
            /* single line text input */
            case 4:
                return {
                    content: JSON.stringify(data),
                    content_value: data
                }
            /* number input */
            case 5:
                return {
                    content: JSON.stringify(data),
                    content_value: data
                }
            /* drop down list */
            case 6:
                if (item.content) {
                    return {
                        content: JSON.stringify({
                            key: JSON.parse(item.content).find(i => data === i.label).key,
                            label: data || "",
                        }),
                        content_value: data || ""
                    }
                } else {
                    return {
                        content: JSON.stringify({
                            key: data || "",
                            label: data || "",
                        }),
                        content_value: data || ""
                    }
                }
            /* 身份证 */
            case 20:
                if (data.name) {
                    return {
                        content: JSON.stringify({
                            ic: data.ic,
                            name: data.name,
                        }),
                        content_value: data.ic
                    }
                } else {
                    return {
                        content: JSON.stringify({
                            ic: '',
                            name: '',
                        }),
                        content_value: ''
                    }
                }
            /* 生日 */
            case 21:
                return {
                    content: data ? data.startOf('day').unix() : "",
                    content_value: data ? data.startOf('day').format('YYYY-MM-DD HH:mm:ss') : ""
                }
            /* 标题 */
            case 22:
                return {
                    content: JSON.stringify(data),
                    content_value: data
                }
            /* 内容 */
            case 23:
                return {
                    content: JSON.stringify(data),
                    content_value: data
                }
            /* video link */
            case 24:
                if (data) {
                    const fileList = data.filter(i => i.response && i.response.code === 0).map(i => { return { ch: i.name, url: i.response.data.url } })
                    return {
                        content: JSON.stringify(fileList),
                        content_value: JSON.stringify(fileList.map(i => i.url)[0])
                    }
                } else {
                    return {
                        content: JSON.stringify([]),
                        content_value: ""
                    }
                }
            /* image file */
            case 25:
                if (data) {
                    const fileList = data.filter(i => i.response && i.response.code === 0).map(i => { return { ch: i.name, url: i.response.data.url } })
                    return {
                        content: JSON.stringify(fileList.map(i => i.url)),
                        content_value: JSON.stringify(fileList.map(i => i.url))
                    }
                } else {
                    return {
                        content: JSON.stringify([]),
                        content_value: JSON.stringify([])
                    }
                }
            /* game role, platform + server + role_id */
            case 26:
                return {
                    content: JSON.stringify({
                        "operator_id": "",
                        "operator_name": "",
                        "server_id": "",
                        "server_name": "",
                        "role_id": "",
                        "role_name": data
                    }),
                    content_value: data
                }
            /* email */
            case 27:
                return {
                    content: JSON.stringify(data),
                    content_value: data
                }
            /* province + city */
            case 28:
                if (data && data.length > 0) {
                    return {
                        content: JSON.stringify({
                            province: data[0],
                            city: data[1]
                        }),
                        content_value: data.join(' ')
                    }
                } else {
                    return {
                        content: JSON.stringify({
                            province: '',
                            city: ''
                        }),
                        content_value: ''
                    }
                }
            /* IM contact */
            case 29:
                /* 区分验证类型与账户 */
                return {
                    content: JSON.stringify([{ ch: 'qq', account: data }]),
                    content_value: data
                }
            /* phone number */
            case 30:
                return {
                    content: JSON.stringify({
                        code: data.code,
                        phone: data.phone
                    }),
                    content_value: data.phone
                }
            default:
                /* 图形验证码 */
                return {
                    content: '',
                    content_value: ''
                }
        };
    }

    return fieldsList.map((item, index) => {
        return {
            type: Number(item.type),
            field_uid: Number(item.uid),
            field_order: 0,
            field_name: item.name,
            required: item.required ? true : false,
            ...fieldsContent(item, index)
        }
    })
}

export default CreateTicketFormFields;
